import { registryApi, walterApi } from '../clients/AxiosClients'

/**
 * Retorna todos os estratos inventario pilha cadastradas no banco de dados
 */
export const getAllEstratoInventarioPilha = async () => {
	return registryApi.get('v1/EstratoInventarioPilha')
}

/**
 * Cadastrar novo estrato inventario pilha no banco de dados
 * @param {Object} body Estrato inventario pilha que será cadastrada
 */
export const createEstratoInventarioPilha = async (body) => {
	return walterApi.post('/ProcessamentoDePilha/processar-medicao-de-pilha', body)
}

/**
 * Atualiza Estrato inventario pilha no banco de dados
 * @param {Object} body Estrato inventario pilha que será atualizada
 */
export const updateEstratoInventarioPilha = async (body) => {
	return registryApi.put('v1/EstratoInventarioPilha', body)
}

/**
 * Lista dos ids de Estrato inventario pilha que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Estrato inventario pilha
 */
export const deleteEstratoInventarioPilhaByIdList = async (data) => {
	return registryApi.delete('v1/EstratoInventarioPilha/DeleteByIdList', {
		data,
	})
}

export const getMedicoesPilhaDropdown = async () => {
	return registryApi.get('v1/Medicao/get-medicoes-pilha-dropdown')
}
